import React from 'react';
import { motion } from 'framer-motion';
export function AboutSection() {
  return <section id="about" className="pt-24 md:pt-32 pb-8 md:pb-12 bg-bg-warm relative overflow-hidden" data-id="element-13">
      <div className="max-w-7xl mx-auto px-4 md:px-6" data-id="element-14">
        {/* Mission Statement */}
        <motion.div initial={{
        opacity: 0,
        y: 30
      }} whileInView={{
        opacity: 1,
        y: 0
      }} viewport={{
        once: true,
        margin: '-100px'
      }} transition={{
        duration: 0.8,
        ease: [0.16, 1, 0.3, 1]
      }} className="max-w-4xl mx-auto text-center mb-16 md:mb-24" data-id="element-15">
          <div className="flex items-center justify-center space-x-4 mb-10" data-id="element-16">
            <span className="h-px w-12 bg-accent block" data-id="element-17"></span>
            <span className="text-accent uppercase tracking-widest text-sm font-light" data-id="element-18">
              Our Philosophy
            </span>
            <span className="h-px w-12 bg-accent block" data-id="element-19"></span>
          </div>

          <h2 className="text-3xl md:text-4xl lg:text-5xl font-light text-primary leading-snug md:leading-relaxed tracking-tight mb-10" data-id="element-20">
            We believe in sustainable, design-driven and{' '}
            <span className="text-accent" data-id="element-21">human-centred</span> architecture.
          </h2>

          <p className="text-text-muted text-lg md:text-xl font-light leading-relaxed mb-8" data-id="element-22">
            We believe that design is an expression of an imagination of space
            and form that stems from the core value of an experience of
            enjoyment and intimacy with the environment.
          </p>

          <p className="text-text-muted text-lg md:text-xl font-light leading-relaxed" data-id="element-23">
            Our passion is to use architecture and design to balance and restore
            the heart, mind and body, resounding in perfect harmony.
          </p>
        </motion.div>

        {/* About Content - full width for image bleed */}
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-0 items-stretch" data-id="element-24">
          {/* Image - full bleed left */}
          <motion.div initial={{
          opacity: 0,
          y: 40,
          rotateX: 6
        }} whileInView={{
          opacity: 1,
          y: 0,
          rotateX: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 1,
          delay: 0.2,
          ease: [0.16, 1, 0.3, 1]
        }} style={{
          perspective: 1000,
          transformOrigin: 'top center'
        }} className="relative h-[500px] lg:h-auto w-full" data-id="element-25">
            <img src="https://cdn.magicpatterns.com/uploads/pwFiYCWA5yYdTaNmKWSoHE/pasted-image.webp" alt="Modern multi-story residential architecture surrounded by lush greenery" className="w-full h-full object-cover" data-id="element-26" />
          </motion.div>

          {/* Text Content */}
          <motion.div initial={{
          opacity: 0,
          x: 50
        }} whileInView={{
          opacity: 1,
          x: 0
        }} viewport={{
          once: true,
          margin: '-100px'
        }} transition={{
          duration: 0.8,
          ease: [0.16, 1, 0.3, 1]
        }} className="flex flex-col space-y-16 px-4 md:px-6 lg:px-12 xl:px-16 py-12 lg:py-16" data-id="element-27">
            <div className="space-y-8" data-id="element-28">
              <div className="flex items-center space-x-4" data-id="element-29">
                <span className="h-px w-12 bg-accent block" data-id="element-30"></span>
                <span className="text-accent uppercase tracking-widest text-sm font-light" data-id="element-31">
                  About Us
                </span>
              </div>

              <p className="text-primary text-xl md:text-2xl font-light leading-relaxed" data-id="element-32">
                JRP Design Inc. is an architectural practice with 25+ years of
                experience delivering thoughtful, practical design solutions.
              </p>

              <p className="text-text-muted text-lg font-light leading-relaxed" data-id="element-33">
                Our work spans residential, commercial, and industrial projects:
                from new construction to major renovations. Guided by principles
                of integrity, functionality, and thoughtful design, we focus on
                creating buildings that perform well, endure over time, and
                respond meaningfully to their environment.
              </p>
            </div>

            {/* Founder Section */}
            <motion.div initial={{
            opacity: 0,
            y: 30
          }} whileInView={{
            opacity: 1,
            y: 0
          }} viewport={{
            once: true,
            margin: '-50px'
          }} transition={{
            duration: 0.8,
            ease: [0.16, 1, 0.3, 1]
          }} className="space-y-8 pt-8 border-t border-neutral-200" data-id="element-34">
              <div className="flex items-center space-x-4" data-id="element-35">
                <span className="h-px w-12 bg-accent block" data-id="element-36"></span>
                <span className="text-accent uppercase tracking-widest text-sm font-light" data-id="element-37">
                  Principal Architect
                </span>
              </div>

              <h3 className="text-xl md:text-2xl font-light text-primary leading-relaxed" data-id="element-38">
                John Pangilinan
              </h3>

              <div className="space-y-6 text-text-muted text-lg font-light leading-relaxed" data-id="element-39">
                <p data-id="element-40">
                  John is the founding principal of JRP Design Inc., established
                  in 2002. With over 25 years of experience in architectural
                  practice, his work focuses on creating functional, enduring
                  spaces that are grounded in thoughtful design and
                  environmental responsibility.
                </p>
                <p data-id="element-41">
                  He studied architecture at the University of the Philippines
                  Diliman, where he trained under Philippine National Artist
                  Bobby Mañosa. He later pursued postgraduate studies in Low
                  Energy Architecture at the University of North London while
                  completing coursework at Cambridge University.
                </p>
              </div>
            </motion.div>
          </motion.div>
        </div>
      </div>
    </section>;
}